import { ILoan } from 'redux/reducers/userApplications/type';

type loanHistory = ILoan[];

interface CompareResult {
  isNeedAction: boolean;
}

export const compareLoanHistories = (prev: loanHistory, current: loanHistory): CompareResult => {
  const prevMap = new Map(prev.map((obj) => [obj.id, obj.state]));
  let isNeedAction = false;

  current.forEach((obj) => {
    const prevState = prevMap.get(obj.id);

    if (prevState !== undefined && prevState !== obj.state) {
      isNeedAction = true;
    }
  });

  return { isNeedAction };
};
